export const enum ContentType {
	messageMetadata     = "MessageMetadata",    // metadata about messages
	userGovernanceRules = "UserGovernance",     // user Governance (ATC) from IRIS
	campaignContent     = "CampaignContent",    // campaigns for Floodgate
	dynamicSettings     = "DynamicSettings",    // dynamic settings from TMS service
	logLevelSettings    = "LogLevelSettings",   // log level settings from TMS service
	userFacts           = "UserFacts",          // user facts from TULIPS service
}

export const ContentTypeToStorageKeyMap: { [k in ContentType]: string } = {
	[ContentType.campaignContent]: "obf-TmsCampaignContent",
	[ContentType.dynamicSettings]: "obf-TmsDynamicSettings",
	[ContentType.logLevelSettings]: "obf-LogLevelSettings",
	[ContentType.messageMetadata]: "obf-TmsMessageMetadata",
	[ContentType.userFacts]: "obf-UserFacts",
	[ContentType.userGovernanceRules]: "obf-TmsUserGovernance",
};
